import React from 'react';
import { portfolioProjects } from '../data/mockData';
import { ArrowUpRight } from 'lucide-react';
import ProjectCarousel from './ProjectCarousel';
import VideoCarousel from './VideoCarousel';

const SelectedWork = () => {
  return (
    <section id="work" className="py-24 px-6 fade-in-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-5xl md:text-6xl font-bold mb-6">
            Selected <span className="text-gold">Work</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            A selection of creative direction, design, and visual production developed 
            within agency environments.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {portfolioProjects.map((project, index) => (
            <div key={index}>
              {project.isCarousel ? (
                <ProjectCarousel 
                  images={project.carouselImages}
                  imageTitles={project.imageTitles}
                  title={project.title}
                  category={project.category}
                />
              ) : project.isVideoCarousel ? (
                <VideoCarousel 
                  videos={project.carouselVideos}
                  posterImages={project.videoPosterImages}
                  videoTitles={project.videoTitles}
                  title={project.title}
                  category={project.category}
                />
              ) : (
                <div className="group relative overflow-hidden cursor-pointer">
                  <div className="aspect-[4/3] overflow-hidden bg-gray-900">
                    <img 
                      src={project.image} 
                      alt={project.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300"></div>
                  </div>
                  
                  <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                    <div className="flex items-start justify-between">
                      <div>
                        <h3 className="font-playfair text-2xl font-bold mb-2">{project.title}</h3>
                        <p className="text-gold text-sm tracking-wide">{project.category}</p>
                      </div>
                      <ArrowUpRight 
                        className="text-magenta opacity-0 group-hover:opacity-100 transition-opacity duration-300" 
                        size={24} 
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SelectedWork;